var map = {
	"./algiz.png": "VGyy",
	"./ansuz.png": "u1iA",
	"./berkana.png": "JNYA",
	"./dagaz.png": "selP",
	"./ehwaz.png": "RLuH",
	"./eihwaz.png": "7Ojr",
	"./fehu.png": "LvE7",
	"./gebo.png": "VCAr",
	"./hagalaz.png": "0enc",
	"./inguz.png": "uy2p",
	"./isa.png": "Ezh6",
	"./jera.png": "77um",
	"./kaunaz.png": "Ml1C",
	"./laguz.png": "wK2i",
	"./mannaz.png": "bkzo",
	"./nauthiz.png": "mh+y",
	"./othila.png": "fedv",
	"./pertho.png": "c24/",
	"./raido.png": "1ZLI",
	"./sowulo.png": "LPSy",
	"./teiwaz.png": "N5QX",
	"./thurisaz.png": "lB47",
	"./uruz.png": "Axdr",
	"./wird.png": "biog",
	"./wunjo.png": "Fd8G"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MMlX";